module.exports = __webpack_public_path__ + "static/media/logo10-grey.2e0d8be6.png";